import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL_Dione

export const axiosDne = axios.create({
    baseURL: API_URL,
    withCredentials: true
})